import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

const Button = styled.button<{ color: string; loading?: string }>`
  height: 60px;
  color: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.white
      : props.theme.colors.primary};
  background: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.primary
      : props.theme.colors.white};
  text-transform: uppercase;
  padding: ${(props) => (props.loading === 'true' ? '0 24px' : '19px 24px')};
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '10px'};
  font-size: 16px;
  font-weight: bold;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color: string;
  loading?: boolean;
  text?: string;
  loadingComponent?: ReactNode;
}

const DebtButton: React.FC<ButtonProps> = ({
  color,
  loading,
  text,
  loadingComponent,
  ...props
}) => {
  return (
    <Button color={color} loading={String(loading)} {...props}>
      {loading ? loadingComponent : text}
    </Button>
  );
};

export default DebtButton;
